module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Company name","site":"Website","about":"About","address":"Address","addAddress":"New address","logo":"Logo","uploadLogo":"Upload logo","pictureTypeTip":"jpg, png no more than 1MB","delete":"Delete","close":"Close","upload":"Upload","save":"Save","dataSave":"Data saved","pictureTypeTip2":"jpg, png no larger than 5MB","officePictures":"Office pictures"}}')
  delete Component.options._Ctor
}
